// @flow
import React from 'react'
import ChangePasswordForm from './form'

const ChangePassword = (): any => {
  return (
    <div className='pw-reset-password'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Set a new password</h3>
        <h4 className='login__subtitle'>Please enter a new password for your account.</h4>
      </div>
      <ChangePasswordForm />
    </div>
  )
}

ChangePassword.displayName = 'ChangePassword'

export default ChangePassword
